"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const react_redux_1 = require("react-redux");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete/Autocomplete"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const core_1 = require("@material-ui/core");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
require("./contactInfo.scss");
const PhoneMask = (props) => {
    return (react_1.default.createElement(react_input_mask_1.default, Object.assign({}, props, { mask: "(999) 999-9999", maskChar: " " })));
};
const PostalCodeMask = (props) => {
    return (react_1.default.createElement(react_input_mask_1.default, Object.assign({}, props, { placeholder: '', mask: "99999", maskChar: "" })));
};
const editProps = [
    [
        {
            name: "Main Phone Number",
            key: "phone.mobile",
            masked: PhoneMask
        },
        {
            name: "Extra Phone Number",
            key: "phone.office",
            masked: PhoneMask
        }
    ],
    [
        {
            name: "Fax",
            key: "phone.fax",
            masked: PhoneMask
        }
    ],
    [
        {
            name: "Email",
            key: "email"
        }
    ]
];
const addressProps = [
    [
        {
            name: "",
            key: "possibleAddresses"
        }
    ],
    [
        {
            name: "Address",
            key: "address.street_address"
        },
        {
            name: "City",
            key: "address.city"
        }
    ],
    [
        {
            name: "State",
            key: "address.stateFullName",
            autocomplete: true,
            dataKey: "states"
        },
        {
            name: "Zip",
            key: "address.zip",
            masked: PostalCodeMask
        }
    ]
];
const ContactInfo = (props) => {
    const { expert } = props;
    const onEdit = (e, key) => {
        const val = e.target.value;
        if (key === 'address.stateFullName') {
            props.editExpert({ key: 'address.stateFullName', val: val.name });
            props.editExpert({ key: 'address.state', val: val.abbreviation });
        }
        else {
            props.editExpert({ key, val });
        }
    };
    const setAddress = (data) => {
        for (const prop of Object.keys(data)) {
            props.editExpert({ key: `address.${prop}`, val: data[prop] });
        }
    };
    const inputsRenderer = (inputProps) => {
        return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, inputProps.map((arr, key) => {
                return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, key: key }, arr === null || arr === void 0 ? void 0 : arr.map((val, key) => {
                    let value = get_1.default(expert, val.key);
                    let options = [];
                    if (val.autocomplete) {
                        options = get_1.default(props, val.dataKey) || [];
                        value = options.find(o => o.name === value);
                        value = value || { name: "" };
                    }
                    return (react_1.default.createElement(core_1.Grid, { key: key, item: true, xs: val.key === 'possibleAddresses' ? 12 : 6, className: "item-field" }, val.key === 'possibleAddresses' ? react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("h5", { className: 'mb-5' }, "Possible addresses"),
                        react_1.default.createElement(core_1.List, null, value === null || value === void 0 ? void 0 : value.map((val, key) => react_1.default.createElement(core_1.ListItem, { onClick: () => setAddress(val), className: 'no-margin no-padding', style: {
                                cursor: "pointer"
                            }, key: key },
                            react_1.default.createElement(core_1.ListItemText, null, val.fullAddress))))) : (val.autocomplete && options.length) ?
                        react_1.default.createElement(Autocomplete_1.default, { key: key, value: value, closeIcon: react_1.default.createElement("span", { className: "color-medium-gray" },
                                react_1.default.createElement(Clear_1.default, { fontSize: "inherit", color: "inherit" })), popupIcon: react_1.default.createElement("span", { className: "color-medium-gray" },
                                react_1.default.createElement(ExpandMore_1.default, { color: "inherit" })), onChange: (e, v) => {
                                if (e) {
                                    onEdit({
                                        target: {
                                            value: v
                                        }
                                    }, val.key);
                                }
                            }, options: options, getOptionLabel: (option) => option.name, renderInput: (params) => react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: val.name, variant: "outlined", className: 'contact-info-input' })) }) : react_1.default.createElement(core_1.TextField, { className: 'contact-info-input', variant: "outlined", key: key, onChange: (e) => onEdit(e, val.key), margin: "dense", id: val.key, label: val.name, type: "text", defaultValue: value || "", fullWidth: true, InputProps: val.masked ? {
                            inputComponent: val.masked,
                        } : {} })));
                })));
            }))));
    };
    return expert ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks contact-info', square: true },
            react_1.default.createElement("h5", null, "Contact Information"),
            inputsRenderer(editProps)),
        react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks contact-info', square: true },
            react_1.default.createElement("h5", null, "Address Info"),
            inputsRenderer(addressProps)))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts, staticData } = state;
    return {
        expert: experts.editableExpert || experts.expert,
        states: staticData.states
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
